import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=44ff0f4c&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=44ff0f4c&scoped=true&lang=scss&"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff0f4c",
  null
  
)

export default component.exports